// extracted by mini-css-extract-plugin
export default {"bulkMenu":"BulkMenu__bulkMenu___1-Luf","bulkTitle":"BulkMenu__bulkTitle___2r9M9","ButtonStyle":"BulkMenu__ButtonStyle___cjVrx"};